@let blok = block();
<div class="s1-grid-column--1 flex flex-col"
     [ngClass]="column1Classes()">
    @for (child of blok.children; track child._uid) {
        <s1-cms-component [blok]="child" />
    }
</div>
